export default "__VITE_ASSET__CrGMCWn6__"